import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// assets
import "./index.css";
import "./css/base.css";

// module
import L10N from "./L10NModule";

//#region Banner
import img_banner from "./assets/images/banner.png";
function Banner() {
  return (
    <div className="home-section banner">
      <img src={img_banner} alt="Banner" />
    </div>
  );
}
//#endregion

//#region WhyChooseUs
import img_why_1 from "./assets/images/why_1.png";
import img_why_2 from "./assets/images/why_2.png";
import img_why_3 from "./assets/images/why_3.png";
function WhyChooseUs() {
  return (
    <div className="home-section why">
      <h2>{L10N.Static_Get(L10N.StaticConst.why)}</h2>
      <ul>
        <li>
          <img src={img_why_1} alt="Innovative Game Design" />
          <p>{L10N.Static_Get(L10N.StaticConst.innovitive)}</p>
        </li>

        <li>
          <img src={img_why_2} alt="Creative Expertise" />
          <p>{L10N.Static_Get(L10N.StaticConst.creative)}</p>
        </li>

        <li>
          <img src={img_why_3} alt="Ongoing Support And Updates" />
          <p>{L10N.Static_Get(L10N.StaticConst.ongoing)}</p>
        </li>

      </ul>
    </div>
  );
}
//#endregion

//#region Works
import img_work_1 from "./assets/images/works/1/cover.png";
import img_work_2 from "./assets/images/works/2/cover.png";
import img_work_3 from "./assets/images/works/3/cover.png";

function Works() {
  const works = [
    { img: img_work_1, alt: "Work 1", url: "/works/1" },
    { img: img_work_2, alt: "Work 2", url: "/works/2" },
    { img: img_work_3, alt: "Work 3", url: "/works/3" }
  ];
  return (
    <div className="home-section works">
      <h2>{L10N.Static_Get(L10N.StaticConst.work)}</h2>
      <ul>
        {works.map((work, index) => (
          <li key={`works_${index}`}>
            <a href={work.url}>
              <img src={work.img} alt={work.alt} />
            </a>
          </li>
        ))}
      </ul>
      <a className="view-all" href="/work">{L10N.Static_Get(L10N.StaticConst.view)}</a>
    </div>
  );
}
//#endregion

//#region Contact
import img_email from "./assets/images/email.png";
import img_phone from "./assets/images/phone.png";
import img_address from "./assets/images/address.png";

function Contact() {
  return (
    <div className="home-section contact">
      <h2>{L10N.Static_Get(L10N.StaticConst.contact)}</h2>
      <ul>
        <li>
          <img src={img_email} alt="Email" />
          <h4>{L10N.Static_Get(L10N.StaticConst.email)}</h4>
          <p>linqizhi@9e.games</p>
        </li>
        <li>
          <img src={img_phone} alt="Phone" />
          <h4>{L10N.Static_Get(L10N.StaticConst.phone)}</h4>
          <p>17700080848</p>
        </li>
        <li>
          <img src={img_address} alt="Address" />
          <h4>{L10N.Static_Get(L10N.StaticConst.address)}</h4>
          <p>福建省厦门市集美区<br></br>软件园三期b区13栋602-2</p>
        </li>
      </ul>
    </div>
  )
}
//#endregion

//#region AddressMap
//#region Banner
import img_map from "./assets/images/map.png";
function AddressMap() {
  return (
    <div className="home-section address-map">
      <img src={img_map} alt="Map" />
    </div>
  );
}
//#endregion
//#endregion

//#region Body
import { Com_Header } from "./Component/Header";
import { Com_Footer } from "./Component/Footer";
function Body() {
  return (
    <div className="body">
      <Banner />
      <WhyChooseUs />
      <Works />
      <Contact />
      <AddressMap />
    </div>
  );
}

function Page_Index() {
  return (
    <div className="app">
      <Com_Header />
      <Body />
      <Com_Footer />
    </div>
  );
}
//#endregion

//#region App
const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <Page_Index />
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
//#endregion